module.exports = __webpack_public_path__ + "img/icon_2_6.e655ef08.png";